"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGIN_PASSWORD_PATTERN = exports.LOGIN_PASSWORD_MESSAGE = exports.LOGIN_ACCOUNT_PATTERN = exports.LOGIN_ACCOUNT_MESSAGE = void 0;
exports.validateLoginAccount = validateLoginAccount;
exports.validateLoginPassword = validateLoginPassword;
/** 账号：长度大于 8 位 */
var LOGIN_ACCOUNT_PATTERN = exports.LOGIN_ACCOUNT_PATTERN = /^.{9,}$/;

/** 密码：长度大于 8 位，且包含字母和数字 */
var LOGIN_PASSWORD_PATTERN = exports.LOGIN_PASSWORD_PATTERN = /^(?=.*[A-Za-z])(?=.*\d).{9,}$/;
var LOGIN_ACCOUNT_MESSAGE = exports.LOGIN_ACCOUNT_MESSAGE = '账号长度必须大于8位';
var LOGIN_PASSWORD_MESSAGE = exports.LOGIN_PASSWORD_MESSAGE = '密码长度必须大于8位，且需包含字母和数字';
function validateLoginAccount(account) {
  return LOGIN_ACCOUNT_PATTERN.test(String(account || '').trim());
}
function validateLoginPassword(password) {
  return LOGIN_PASSWORD_PATTERN.test(password || '');
}